import React from 'react'
import { ArrowRight } from 'lucide-react'

// Link de acción tipo "Solicitar" / "Continuar" / "Ver detalles": texto
// azul + flecha, usado en las tarjetas de "Mis cotizaciones" y "Mis
// arrendamientos". Si no se pasa onClick, se renderiza deshabilitado (sin
// interacción) — útil para acciones que todavía no tienen a dónde navegar.
export const ActionLink: React.FC<{
  label: string
  onClick?: () => void
  // true mientras la acción está en curso (p. ej. esperando la respuesta
  // del backend) — deshabilita el botón y muestra un spinner en vez del
  // label, para que el usuario sepa que su clic sí tuvo efecto.
  isLoading?: boolean
}> = ({ label, onClick, isLoading = false }) => (
  <button
    type="button"
    disabled={!onClick || isLoading}
    onClick={e => {
      e.stopPropagation()
      onClick?.()
    }}
    className={`flex items-center gap-1.5 text-sm font-semibold shrink-0 ${
      onClick && !isLoading
        ? 'text-olr-primary hover:text-olr-primary-hover'
        : 'text-gray-300 cursor-default'
    }`}
  >
    {isLoading ? (
      <>
        <span className="h-3.5 w-3.5 rounded-full border-2 border-gray-300 border-t-olr-primary animate-spin" />
        Solicitando…
      </>
    ) : (
      <>
        {label}
        <ArrowRight size={16} />
      </>
    )}
  </button>
)
